import React, { useState, useRef, useContext, useEffect } from "react";
import "../styles/settings/security.css";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import {Link} from 'react-router-dom';

const SecuritySettings = () => {
  const { changeTransactionPin } = useContext(AuthContext);

  const [currentPin, setCurrentPin] = useState(["", "", "", ""]);
  const [newPin, setNewPin] = useState(["", "", "", ""]);
  const [confirmPin, setConfirmPin] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [pinMismatch, setPinMismatch] = useState(false);

  const currentRefs = useRef([]);
  const newRefs = useRef([]);
  const confirmRefs = useRef([]);

  const handleChange = (index, value, pinState, setPinState, refs) => {
    if (!/^\d?$/.test(value)) return;
    const updated = [...pinState];
    updated[index] = value;
    setPinState(updated);
    if (value && index < 3) refs.current[index + 1]?.focus();
  };

  const isFormValid = () => {
    const allFilled = [...currentPin, ...newPin, ...confirmPin].every(val => val !== "");
    const newPinMatch = newPin.join("") === confirmPin.join("");
    return allFilled && newPinMatch;
  };

  useEffect(() => {
    const allFilled = newPin.every(n => n !== "") && confirmPin.every(n => n !== "");
    const match = newPin.join("") === confirmPin.join("");
    setPinMismatch(allFilled && !match);
  }, [newPin, confirmPin]);

  const handleSubmit = async () => {
    if (!isFormValid()) {
      toast.error("Please fill in all fields and ensure new PINs match.");
      return;
    }

    setLoading(true);

    const response = await changeTransactionPin(
      currentPin.join(""),
      newPin.join("")
    );

    setLoading(false);

    if (response.success) {
      toast.success("PIN changed successfully!");
      setCurrentPin(["", "", "", ""]);
      setNewPin(["", "", "", ""]);
      setConfirmPin(["", "", "", ""]);
      setPinMismatch(false);
    } else {
      toast.error(response.error || "Failed to change PIN.");
    }
  };

  const renderPinInputs = (pinState, setPinState, refs, label, showError = false) => (
    <div className="pin-block">
      <p className="pin-label">{label}</p>
      <div className="pin-input-row">
        {pinState.map((val, i) => (
          <input
            key={i}
            type="password"
            inputMode="numeric"
            maxLength={1}
            value={val}
            className={`pin-input ${showError ? "error" : ""}`}
            ref={el => (refs.current[i] = el)}
            onChange={(e) => handleChange(i, e.target.value, pinState, setPinState, refs)}
          />
        ))}
      </div>
      {showError && (
        <p className="error-input">*New PIN and Confirm PIN do not match</p>
      )}
    </div>
  );

  return (
    <div className="security-otp-container">
      <p className="security-info-text">
        Kindly enter a unique 4-digit PIN that is difficult to guess and only known to you.
      </p>

      {renderPinInputs(currentPin, setCurrentPin, currentRefs, "Current PIN")}
      {renderPinInputs(newPin, setNewPin, newRefs, "New PIN")}
      {renderPinInputs(confirmPin, setConfirmPin, confirmRefs, "Confirm New PIN", pinMismatch)}

      <div className="forgot-pin">
        <Link to = "/forgot-pin">Forgot PIN?</Link>
      </div>

      <button 
        className="change-pin-btn"
        disabled={!isFormValid() || loading}
        onClick={handleSubmit}
      >
        {loading ? "Changing..." : "Change PIN"}
      </button>
    </div>
  );
};

export default SecuritySettings;
